import { Button } from "@omni/ui/components/Button/button.component";
import { cn } from "@omni/utils/styles";
import { MouseEvent } from "react";

import { useAvailableInStore } from "@/components/Search/SearchResults/hooks/useAvailableInStore/useAvailableInStore.hook";
import { StorePickerModal } from "@/components/Store/StorePicker/storePickerModal.container";
import { StorePickerType } from "@/components/Store/StorePicker/types/storePickerType.enum";
import { useStoreFullName } from "@/components/Store/utils/useStoreFullName.hook";
import { useGranite } from "@/redux/modules/value/translations/translations.provider";
import { StorePickerModalStates } from "@/utils/enums";

export const StoreFacetValueComponent = () => {
    const { t } = useGranite();

    const {
        storePickerModalState,
        preferredStore,
        selected,
        count,
        onSelectStore,
        onRefine,
        onStorePickerModalClose,
        onStorePickerModalSubmit
    } = useAvailableInStore();

    const handleOnSelectStoreClick = (event: MouseEvent) => {
        event.preventDefault();
        onSelectStore();
    };

    const storeFullName = useStoreFullName(preferredStore);

    const title = !preferredStore
        ? t("search.facets.store.selectStore")
        : selected
          ? `${t("search.facets.store.availableIn.active")} ${storeFullName}`
          : `${t("search.facets.store.availableIn.inactive")} ${storeFullName}`;

    return (
        <li>
            <label
                className={cn(
                    "tw:cursor-pointer tw:flex tw:flex-col tw:mb-0 tw:py-1"
                )}
                title={title}
            >
                <div className={"tw:min-w-0 tw:flex tw:items-center"}>
                    <input
                        type={"checkbox"}
                        className={cn("tw:mr-2 tw:cursor-pointer")}
                        checked={selected}
                        onChange={preferredStore ? onRefine : undefined}
                        disabled={!count}
                        onClick={
                            preferredStore
                                ? undefined
                                : handleOnSelectStoreClick
                        }
                    />
                    <div
                        className={cn(
                            "tw:first-letter:capitalize tw:whitespace-nowrap tw:overflow-hidden tw:text-ellipsis",
                            { "tw:font-bold": selected }
                        )}
                    >
                        {!preferredStore &&
                            t("search.facets.store.availableIn.noStore")}
                        {preferredStore &&
                            selected &&
                            t("search.facets.store.availableIn.active") +
                                " " +
                                storeFullName}
                        {preferredStore &&
                            !selected &&
                            t("search.facets.store.availableIn.inactive") +
                                " " +
                                storeFullName}
                    </div>
                </div>
                <Button
                    color={"link"}
                    className={cn("tw:p-0 tw:ml-4 tw:pl-1 tw:w-fit")}
                    onClick={handleOnSelectStoreClick}
                >
                    {!preferredStore && t("search.facets.store.selectStore")}
                    {preferredStore && t("search.facets.store.changeStore")}
                </Button>
            </label>
            <StorePickerModal
                isOpen={storePickerModalState !== StorePickerModalStates.Closed}
                type={StorePickerType.SELECT}
                displayStockLevel={false}
                infoLink={null}
                storeCode={preferredStore?.code ?? null}
                fixedFeatures={[]}
                onClose={onStorePickerModalClose}
                onSubmit={onStorePickerModalSubmit}
            />
        </li>
    );
};
